import { useContext } from 'react'
import { LoaderContext } from '@contexts/DataLoader'

export const useDataLoader = () => useContext(LoaderContext)
